import { __awaiter, __generator } from "tslib";
import { JarvisWebHttpClient } from '@jarvis/web-http';
import { ApiDiscoverySvcCache } from './integration/api-discovery-svc';
var StratusClient = /** @class */ (function () {
    // /**
    //  * Default constructor.
    //  *
    //  * @param {union} baseURL the base URL stack, string or async function that returns string of the desired Stratus stack, which should be obtained from the API discovery service
    //  * @param {JarvisAuthProvider} authProvider the auth provider for requests this client will make
    //  */
    function StratusClient(baseURL, authProvider) {
        var _this = this;
        var defaultBaseURL;
        if (typeof baseURL === 'function') {
            defaultBaseURL = function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, baseURL(this.apiName, this.apiVersion)];
                });
            }); };
        }
        else if (typeof baseURL === 'string') {
            defaultBaseURL = function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, baseURL];
                });
            }); };
        }
        else {
            defaultBaseURL = function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, ApiDiscoverySvcCache.getInstance(baseURL).getBaseURL(this.apiName, this.apiVersion, authProvider)];
                });
            }); };
        }
        this.jarvisWebHttpInstance = new JarvisWebHttpClient({
            defaultBaseURL: defaultBaseURL,
            defaultAuthProvider: authProvider,
        });
    }
    return StratusClient;
}());
export { StratusClient };
export var Stack;
(function (Stack) {
    Stack[Stack["dev"] = 0] = "dev";
    Stack[Stack["pie"] = 1] = "pie";
    Stack[Stack["stage"] = 2] = "stage";
    Stack[Stack["prod"] = 3] = "prod";
})(Stack || (Stack = {}));
//# sourceMappingURL=stratus-client.js.map